export default "__VITE_ASSET__44KKxWw0__"